// The per-org reviewer-level drift aggregate arrives with repo '*'
// (death-star#248). Render it readably in the Drift Alerts table. Kept in its
// own module (no DOM imports) so it unit-tests in the node env, matching the
// incidents-poll-button-state.ts convention.
export function repoLabel(repo: string): string {
  return repo === '*' ? 'all repos' : repo;
}
